import RestClient from '../RestClient/RestClient';
import { apiHosts } from '../RestClient/FetchHelper.config';
import { getCookie } from '../helpers/Cookies';
import { cstToUTC, getChannel } from '../Common/CommonHelper';

const DP_PREVIEW_DATE = 'DP_PREVIEW_DATE';

export const getIrisReturnsContent = () => {
    const context = RestClient.getContext();
    let contentUrl = '/content-aggregator/aggregate-pages/m/returns';
    let previewDate = '';
    if (context.isPreview) {
        const dateValue = cstToUTC(getCookie(DP_PREVIEW_DATE), context);
        previewDate = (dateValue || new Date()).toISOString();
        contentUrl = '/prvcontent-aggregator/aggregate-pages/m/returns';
    }
    const channel = getChannel(context); // getting the channel type
    const config = {
        url: contentUrl,
        apiHost: apiHosts.content,
        excludeVersion: true,
        credentials: 'include',
        isXCloudHeaderRequired: true,
        channel,
        previewDate,
    };

    return RestClient.get(config)
        .then((json) => json)
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};

export const getIrisContent = ({ tagId }) => {
    const context = RestClient.getContext();
    let contentUrl = `/content-api/shared-components/zones/S1/s/cf-${tagId}?searchTerm=cf-${tagId}`;
    let previewDate = '';
    if (context.isPreview) {
        const dateValue = cstToUTC(getCookie(DP_PREVIEW_DATE), context);
        previewDate = (dateValue || new Date()).toISOString();
        contentUrl = `/prvcontent-api/shared-components/zones/S1/s/cf-${tagId}?searchTerm=cf-${tagId}`;
    }
    const channel = getChannel(context); // getting the channel type
    const config = {
        url: contentUrl,
        apiHost: apiHosts.content,
        excludeVersion: true,
        credentials: 'include',
        isCMHeaderRequired: false,
        isXCloudHeaderRequired: true,
        channel,
        previewDate,
    };

    return RestClient.get(config)
        .then((json) => json)
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};

export const getCMContent = ({ tagId }) => {
    const context = RestClient.getContext();
    let contentUrl = `/content-aggregator/shared-components/zones/S1/s/cf-${tagId}?searchTerm=cf-${tagId}`;
    let previewDate = '';
    if (context.isPreview) {
        const dateValue = cstToUTC(getCookie(DP_PREVIEW_DATE), context);
        previewDate = (dateValue || new Date()).toISOString();
        contentUrl = `/prvcontent-aggregator/shared-components/zones/S1/s/cf-${tagId}?searchTerm=cf-${tagId}`;
    }
    const channel = getChannel(context);
    const config = {
        url: contentUrl,
        apiHost: apiHosts.content,
        excludeVersion: true,
        credentials: 'include',
        isXCloudHeaderRequired: true,
        isCMHeaderRequired: true, // to get the content from coremedia for pdp content fragment
        channel,
        previewDate,
    };

    return RestClient.get(config)
        .then((json) => json)
        .catch((error) => {
            console.log(`request failed ${error}`);
        });
};
